//Importamos los estilos globales, esto es manejado por webpack
import "style.less";
import 'font-awesome/css/font-awesome.css';

import * as kea from "kea-react";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { App } from "./app";


//Dibujar la aplicación:
ReactDOM.render(<App />, document.getElementById("rootdiv"));


// WEBPACK FOOTER //
// ./app/main/index.tsx